var FlutterwaveInterface = {

    publicKey:'yesssssssssss',
    customerEmail: '',
    customerFirstname: '',
    customerLastname: '',
    amount:'',
    customerPhone:'',
    currency:'',
    transactionReference:'',

    setPaymentDetails: function (requestDetails) {
        this.publicKey = requestDetails.publicKey;
        this.customerEmail = requestDetails.customerEmail;
        this.amount = requestDetails.amount;
        this.customerPhone = requestDetails.customerPhone;
        this.currency = requestDetails.currency;
        this.transactionReference = requestDetails.transactionReference;
        this.customerFirstname = requestDetails.customerFirstname;
        this.customerLastname = requestDetails.customerLastname;

    },

    interactWithFlutterwave: function (paymentCallback) {
        var handler = getpaidSetup({
            PBFPubKey: this.publicKey,
            customer_email: this.customerEmail,
            amount: this.amount,
            customer_firstname: this.customerFirstname,
            customer_lastname: this.customerLastname,
            customer_phone: this.customerPhone,
            currency: this.currency,
            txref: this.transactionReference,
            
            onclose: () => {
                alert('window closed');
            },
            callback: function (response) {
                // var txref = response.tx.txRef; // collect txRef returned and pass to a 					server page to complete status check.
                // console.log("This is the response returned after a charge", response);
                // if (
                //     response.tx.chargeResponseCode == "00" ||
                //     response.tx.chargeResponseCode == "0"
                // ) {
                //     // redirect to a success page
                // } else {
                //     // redirect to a failure page.
                // }

                handler.close(); // use this to close the modal immediately after payment.
                paymentCallback(response);
            }
        });
    }


}

export default FlutterwaveInterface;
